module.exports = __webpack_public_path__ + "img/sleep_galery.7737dcc7.jpeg";